import { createApp, nextTick } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/tokens.css'
import '@/styles/base.css'
import '@/styles/app.css'
import 'virtual:uno.css'
import App from './App.vue'
import router from './router'
import { permissionDirective } from './directives/permission'
import { pinia } from './stores'
import { useAuthStore } from './stores/auth'
import { usePrototypeStore } from './stores/prototype'
import { useTaskStore } from './stores/tasks'
import { useUiStore } from './stores/ui'
import { onUnauthorized } from './services/request'

async function boot(): Promise<void> {
  const app = createApp(App)
  app.use(pinia)
  app.use(ElementPlus)
  app.use(permissionDirective)

  const auth = useAuthStore(pinia)
  const prototype = usePrototypeStore(pinia)
  const tasks = useTaskStore(pinia)
  const ui = useUiStore(pinia)

  // Restore the session before the router performs its first navigation.
  // Deep links therefore resolve to the target page, never to a default home
  // page hidden behind the boot shell.
  auth.restore()
  tasks.addSeedTasks(prototype.db.async_tasks as Array<Record<string, unknown>>)

  onUnauthorized(() => {
    const redirect = router.currentRoute.value.fullPath
    auth.logout('登录状态已过期')
    if (router.currentRoute.value.path !== '/login') {
      void router.replace({ path: '/login', query: { redirect, expired: '1' } })
    }
  })

  const syncOnline = (): void => {
    ui.setOnline(navigator.onLine)
    if (!navigator.onLine) ui.toast('warning', '网络连接已断开', '当前页面与筛选条件已保留，恢复网络后可继续。', 5000)
  }
  window.addEventListener('online', syncOnline)
  window.addEventListener('offline', syncOnline)
  ui.setOnline(navigator.onLine)

  app.use(router)
  await router.isReady()
  app.mount('#app')

  await nextTick()
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      ui.markBooted()
      const shell = document.getElementById('boot-shell')
      shell?.classList.add('is-hidden')
      window.setTimeout(() => shell?.remove(), 280)
    })
  })
}

void boot()
